import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["textContent"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", {
    "aria-label": "processing message",
    class: _normalizeClass({
    [_ctx.getClass('bot')]:_ctx.typingType==0 || _ctx.typingType==3,
    [_ctx.getClass('user')]:_ctx.typingType==1
})
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.getClass('bubble') + ' ' + _ctx.getClass('bubble--processing'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.getClass('processing'))
      }, [
        (!!_ctx.processingDisplayIcon)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('processing__icon'))
            }, [
              (_ctx.processingDisplayIcon === _ctx.IconEnum.DEFAULT || _ctx.processingDisplayIcon === _ctx.IconEnum.RIPPLE)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.getClass('processing--ripple'))
                  }, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", null, null, -1 /* HOISTED */)),
                    _createElementVNode("div", {
                      class: _normalizeClass(_ctx.getClass('delayed-child'))
                    }, null, 2 /* CLASS */)
                  ], 2 /* CLASS */))
                : (_ctx.processingDisplayIcon === _ctx.IconEnum.DUAL_RING)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(_ctx.getClass('processing--dual-ring'))
                    }, null, 2 /* CLASS */))
                  : (_ctx.processingDisplayIcon === _ctx.IconEnum.SPINNER)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(_ctx.getClass('processing--spinner'))
                      }, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-1'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-2'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-3'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-4'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-5'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-6'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-7'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-8'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-9'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-10'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-11'))
                        }, null, 2 /* CLASS */),
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.getClass('child-12'))
                        }, null, 2 /* CLASS */)
                      ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        (!!_ctx.processingDisplayText)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.getClass('processing__text')),
              textContent: _toDisplayString(_ctx.processingDisplayText)
            }, null, 10 /* CLASS, PROPS */, _hoisted_1))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}